/**
 * @generated SignedSource<<9a9963fae1c716157712c26c60c9cd45>>
 * @relayHash 47715c76a9906fe55bbba15c55edc10c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4129d826ecd3d62b203b8d97b370334501abdc474f1d5d474257eb4b0d61ae89

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContextualTitleEmojiQuery$variables = {
  pageAri: string;
  pageTitle: string;
};
export type ContextualTitleEmojiQuery$data = {
  readonly confluence_contextualTitleEmoji: string | null | undefined;
};
export type ContextualTitleEmojiQuery = {
  response: ContextualTitleEmojiQuery$data;
  variables: ContextualTitleEmojiQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageTitle"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "pageAri",
        "variableName": "pageAri"
      },
      {
        "kind": "Variable",
        "name": "pageTitle",
        "variableName": "pageTitle"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_contextualTitleEmoji"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContextualTitleEmojiQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContextualTitleEmojiQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "47715c76a9906fe55bbba15c55edc10c",
    "id": "4129d826ecd3d62b203b8d97b370334501abdc474f1d5d474257eb4b0d61ae89",
    "metadata": {},
    "name": "ContextualTitleEmojiQuery",
    "operationKind": "query",
    "text": "query ContextualTitleEmojiQuery($pageAri:ID!,$pageTitle:String!){confluence_contextualTitleEmoji(pageAri:$pageAri,pageTitle:$pageTitle)}"
  }
};
})();

(node as any).hash = "ea2adc2538a980f084eac87e15d6be03";

export default node;
